import { createFileRoute } from '@tanstack/react-router';

import { ClinicalWorkPage } from '@/features/emr';

export const Route = createFileRoute('/_authenticated/encounters/')({
  component: ClinicalWorkPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Inbox', href: '/encounters' }],
  }),
});
